export const LATITUDE_REGEX =
  /^(\+|-)?(?:90(?:(?:\.0{1,8})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]*)?))$/;

export const LATITUDE_OCPI_REGEX = /^-?[0-9]{1,2}\.[0-9]{5,7}$/;
